<template>
  <div class="sumber-menu">
    <div class="sumber-content">
      <div class="sumber-left">
        <img src="../assets/logo.png" class="logo" />
        <p>KOPERASI SUMBER MAKMUR TEKNOLOGI</p>
      </div>
      <div class="sumber-menubox">
        <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Perkenalan</div>
        <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
          Aktivitas
        </div>
        <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
          Keamanan
        </div>
        <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">
          Hubungi kami
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.sumber-menu {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 9;

  .sumber-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 72px 360px;

    .sumber-left {
      display: flex;
      align-items: center;
      position: relative;

      .logo {
        margin-right: 16px;
        width: 48px;
        height: 48px;
      }

      p {
        font-weight: 700;
        font-size: 24px;
        color: #333333;
      }
    }
  }

  .sumber-menubox {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: ArialMT;
    color: #333333;
    cursor: pointer;

    div {
      margin-right: 40px;
      padding: 8px 13px;
      box-sizing: border-box;
    }
vz
    div:last-child {
      margin-right: 0;
    }
  }

  .select {
    font-weight: 600;
    color: #F5A739;
  }
}
</style>
